<template>
    <div class="top-info-bar announcement-banner">
        <div class="announcement-banner__content">
            <p class="announcement-banner__text">
                <strong class="font-weight-600">NOVO</strong>: Hitrejši in preprostejši postopek sklepanja financiranja.
            </p>
            <router-link :to="{ name: 'user_center_new' }" class="btn btn--primary-outline btn--sm announcement-banner__action">
                Preberi več
                <img src="@assets/images/general/banner-arrow.svg" alt="" width="16" height="16">
            </router-link>
        </div>
        <!-- <button type="button" class="announcement-banner__close" aria-label="Zapri obvestilo" @click="$emit('close')">
            <img src="@assets/images/general/banner-close.svg" alt="" width="24" height="24">
        </button> -->
    </div>
</template>

<script setup lang="ts">
    defineEmits<{ close: [] }>();
</script>
